import React, { Component } from 'react'
import {CheckboxGroupInput, required} from 'react-admin'
import UserCheckField from './UserCheckField'

import styles from './css/styles.module.css'

class UserCheckCom extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [], falg: false };
    }
  
    /*componentDidMount() {
        fetch(`/usernames`)
          .then(res => res.json())
          .then(json => this.setState({ data: json, flag: true}));
        
    }

    componentWillUnmount() {
        this.setState({ falg: false, data: [] })
    }

    render(props) {
        var source = this.props && this.props.source? this.props.source : 'users'
        var label = this.props && this.props.label ? this.props.label : 'Users'
        console.log(source)
        console.log(this.state.data)
        return (
             this.state.flag ? <CheckboxGroupInput  source={source}    label={label} choices={this.state.data }  />: null
        );
      }*/
      render () {
      
        return <UserCheckField props={this.props}/>
        }
}

export default UserCheckCom